import { SVC_A } from './base'
import { ClipType } from './clipType'
export { ClipType }

function requestClip (cameraId, timestamp, cliptype) {
  // get user uuid and token

  const params = {
    camera_uuid: cameraId,
    cliptype, // aligned | short (aligned is a 30 second clip)
    timestamp,
  }

  return SVC_A.post('/api/v4/clip', params)
}

function requestNextClips (cameraId, timestamp) {
  return SVC_A.get(`/api/v4/clips/${cameraId}/${timestamp}`)
}
/**
 * Fetch the playback URL for a clip.
 *
 * @export
 * @param {any} timestamp The timestamp to look up.
 * @param {any} cameraId The UUID of the camera we want a stream form.
 * @param {any} clipType The clip type. See ClipType.JS for valid values.
 */
export function getClipURL (timestamp, cameraId, clipType) {
  const rawClipType = ClipType.properties[clipType].rawValue

  return new Promise((resolve, reject) => {
    requestClip(cameraId, timestamp, rawClipType).then(res => {
      if (!res) {
        reject(new Error('No response from server.'))
      }

      if (!res.data) {
        reject(new Error('Response from server has no data.'))
      }

      if (!res.data.ok) {
        if (!res.data.err) {
          reject(new Error('Response from server has data, but doesn\'t accurately describe what failed. Check your network connection.'))
        }

        reject(new Error(res.data.err))
      }

      resolve(res)
    }).catch(function (error) {
      reject(error)
    })
  })
}

export function getNextClips (cameraId, timestamp) {
  return new Promise((resolve, reject) => {
    requestNextClips(cameraId, timestamp).then(res => {
      if (!res) {
        reject(new Error('No response from server.'))
      }

      if (!res.data) {
        reject(new Error('Response from server has no data.'))
      }

      if (!res.data.ok) {
        if (!res.data.err) {
          reject(new Error('Response from server has data, but doesn\'t accurately describe what failed. Check your network connection.'))
        }

        reject(new Error(res.data.err))
      }

      resolve(res)
    }).catch(function (error) {
      reject(error)
    })
  })
}
